import PropTypes from 'prop-types';

const pagePropType = PropTypes.shape({
  contextFilters: PropTypes.bool.isRequired,
  searchHeader: PropTypes.bool,
  mainFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  urlParams: PropTypes.arrayOf(PropTypes.string).isRequired,
  pageFilters: PropTypes.arrayOf(PropTypes.string),
  path: PropTypes.arrayOf(PropTypes.string).isRequired,
});

const PageInfoPropType = PropTypes.shape({
  pages: PropTypes.arrayOf(pagePropType),
});

export { PageInfoPropType };
